<template>

  <section class="o-section">
    <div class="o-section__wrapper is-top-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="11a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureA2" data-scene="11a2">
          <Img :src="require('@/assets/scene11/spread11_a2.png')" filename="spread11_a2" />
        </figure>

        <figure class="o-section__figure anim-scene-11" ref="figureA" data-scene="11a">
          <Img :src="require('@/assets/scene11/spread11_a.png')" filename="spread11_a" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene11',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene11', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2],
        // scale: [1.1, 1],
        translateY: ['20px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2],
          opacity: [0, 1],
          delay: 500,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2],
          filter: ['blur(10px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureA2.querySelector('div'),
        rotate: ['-1deg', '0deg'],
        duration: 200,
        delay: 700,
        easing: this.options.easing,
        direction: 'alternate',
        loop: true
      })
    }
  },

  components: {
    Img
  }
}
</script>
